const { createContext, useState, useEffect, useContext } = require('react');

const DynamicFormContext = createContext();

const defaultValues = {
  gender: 'man',
  age: 'middle',
};

export function getDynamicFormFromLocalStorage() {
  const savedForm = localStorage.getItem('dynamicQuizForm');
  if (savedForm) {
    return { ...defaultValues, ...JSON.parse(savedForm) };
  }
  return defaultValues;
}

export const DynamicForm = ({ children }) => {
  const [form, setForm] = useState(getDynamicFormFromLocalStorage());

  const setValue = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const getValue = (key) => {
    return form[key];
  };

  useEffect(() => {
    localStorage.setItem('dynamicQuizForm', JSON.stringify(form));
  }, [form]);

  return (
    <DynamicFormContext.Provider value={{ form, setValue, getValue }}>
      {children}
    </DynamicFormContext.Provider>
  );
};

export const useDynamicForm = () => {
  const context = useContext(DynamicFormContext);
  if (!context) {
    throw new Error('useDynamicForm must be used within a DynamicFormProvider');
  }
  return context;
};
